import { useEffect, useState } from "react";

const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState<"mobile" | "tablet" | "laptop" | "desktop">("desktop");

  useEffect(() => {
    const getScreenSize = () => {
      const width = window.innerWidth;
      if (width < 640) return "mobile";
      if (width < 1024) return "tablet";
      if (width < 1536) return "laptop";
      return "desktop";
    };

    const handleResize = () => {
      setScreenSize(getScreenSize());
    };

    // Set initial size
    setScreenSize(getScreenSize());

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return screenSize;
};

export default useScreenSize;
